import { HTMLAttributes } from 'react'
import { Box } from '@mui/material'
import { useLenis } from 'lenis/react'

import { useScrollbar } from '@/contexts/lenis'

export type ScrollbarProps = HTMLAttributes<HTMLDivElement>

const Scrollbar = ({ className, ...props }: ScrollbarProps) => {
  const lenis = useLenis()
  const [track, thumb, needsScrollbar] = useScrollbar(lenis)

  return (
    <Box
      sx={{
        zIndex: 100,
        position: 'fixed',
        right: 0,
        top: 0,
        bottom: 0,
        width: '1rem',
        touchAction: 'none',
        visibility: needsScrollbar ? 'visible' : 'hidden',
        pointerEvents: needsScrollbar ? 'auto' : 'none',
        ['@media (pointer: coarse)']: {
          visibility: 'hidden',
          pointerEvents: 'none'
        }
      }}
      className={className}
      {...props}
    >
      <Box ref={track} sx={{ position: 'relative', height: '100%', width: '100%' }}>
        <Box
          ref={thumb}
          sx={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            // Thumb style (simulate before pseudo-element)
            '&::before': {
              content: '""',
              position: 'absolute',
              left: '0.2rem',
              top: '0.2rem',
              bottom: '0.2rem',
              width: '0.6rem',
              borderRadius: '999px',
              backgroundColor: (theme) => theme.palette.primary.main
            }
          }}
        />
      </Box>
    </Box>
  )
}

export default Scrollbar
